export default "__VITE_ASSET__8037ebe0__"